export const PAYMENT_METHODS = ['Dinheiro', 'PIX', 'Débito', 'Crédito', 'Outro'] as const;

export const PAYMENT_ICONS: Record<string, string> = {
  Dinheiro: 'payments',
  PIX: 'pix',
  Débito: 'credit_card',
  Crédito: 'credit_score',
  Outro: 'more_horiz',
};
